import { axios } from "./axios";
import _ from "lodash";

// const API_URL = "http://localhost:3000/";

const getMedias = (contentType, params) => {
  let group = _.get(params, "group", null);
  if (group === "_default") {
    group = undefined;
  }

  if (process.env.MOCK_API) {
    return new Promise((resolve) => {
      const imagesData = require("../testData/api/mediaLibraryImages.json");
      resolve(imagesData);
    });
  }

  return axios({
    url: "/upload",
    method: "get",
    params: {
      filter: {
        content_type: contentType,
        group: group,
      },
      page: params.page,
      limit: params.limit,
    },
  });
};

const getAll = () => {
  // return axios.get(API_URL + "templates/all");
};

export { getMedias, getAll };
